'use client'

import { HomeContainer } from '@/components/common'
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from '@/components/ui/carousel'
import { ImageHelper } from '@/lib/helpers/image.helper'
import Autoplay from 'embla-carousel-autoplay'
import Image from 'next/image'

export const CoolClubMoments = () => {
  const moments = [
    {
      src: '/image/2026/12/29/mceclip1_52.png',
      alt: 'CoolClub Moment 1',
    },
    {
      src: '/image/2026/12/29/mceclip2_63.png',
      alt: 'CoolClub Moment 2',
    },
    {
      src: '/image/2026/12/29/mceclip3_74.png',
      alt: 'CoolClub Moment 3',
    },
    {
      src: '/image/2026/12/29/mceclip4_66.png',
      alt: 'CoolClub Moment 4',
    },
    {
      src: '/image/2026/12/29/mceclip5_81.png',
      alt: 'CoolClub Moment 5',
    },
    {
      src: '/image/2026/12/29/mceclip6_42.png',
      alt: 'CoolClub Moment 6',
    },
  ]

  return (
    <HomeContainer className='lg:flex'>
      <Image
        src={ImageHelper.getImageUrl('/image/April2025/mceclip0.png')}
        alt='CoolClub Moments'
        width={420}
        height={239}
        className='mx-auto mb-9 rounded-2xl object-cover lg:mb-0'
      />

      <div>
        <Carousel
          opts={{
            align: 'start',
            duration: 50,
            slidesToScroll: 2,
            skipSnaps: true,
          }}
          plugins={[
            Autoplay({
              delay: 5000,
              stopOnInteraction: false,
            }),
          ]}
          className='h-full w-full'
        >
          <CarouselContent className='will-change-transform lg:ml-0'>
            {moments.map((moment) => (
              <CarouselItem className='basis-1/2 md:basis-1/4' key={moment.src}>
                <Image
                  src={ImageHelper.getImageUrl(moment.src)}
                  alt={moment.alt}
                  width={207}
                  height={200}
                  className='w-auto rounded-md object-cover'
                />
              </CarouselItem>
            ))}
          </CarouselContent>
        </Carousel>
      </div>
    </HomeContainer>
  )
}
